export default __webpack_public_path__ + "static/media/location(1).1939122f.svg";